import axios from '@axios'

export const state = {
  autochecks: [],
  filteredAutochecks: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allAutochecks: (state) => state.autochecks,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_AUTOCHECKS: (state, resp) => {
    if (!resp) return null
    state.autochecks = resp.autochecks
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  ADD_AUTOCHECK: (state, autocheck) => {
    state.autochecks.unshift(autocheck)
  },
  SET_FILTERED_AUTOCHECKS: (state, filteredAutochecks) => {
    state.filteredAutochecks = filteredAutochecks
  },
}

export const actions = {
  async getAutocheck({ commit }, params) {
    await axios
      .get('/api/autochecks', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_AUTOCHECKS', data)
        }
      })
      .catch(() => {
        commit('GET_AUTOCHECKS', null)
      })
  },
  async autoCheck({ commit, dispatch }, form) {
    await axios
      .post('/api/autochecks', form)
      .then((resp) => {
        if (resp.status === 201) {
          commit('ADD_AUTOCHECK', resp.data)
          let notification = {
            id: Date.now(),
            message: 'VIN check report is successfully generated',
            title: 'Autocheck',
            type: 'success',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        } else if (resp.status === 200 && resp.data && resp.data.disabled) {
          let notification = {
            id: Date.now(),
            message: resp.data.message,
            title: 'Autocheck',
            type: 'warning',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        }
      })
      .catch((err) => {
        let notification = {
          id: Date.now(),
          message: `${err.response.VIN} ${err.response.status}`,
          title: err.response.type.toUpperCase(),
          type: 'error',
        }
        dispatch('notification/addNotification', notification, {
          root: true,
        })
      })
  },
  filterAutocheckByVIN({ commit, state }, vin) {
    const filteredAutochecks = state.autochecks.filter(
      (autocheck) => autocheck.vin === vin
    )
    commit('SET_FILTERED_AUTOCHECKS', filteredAutochecks)
  },
  async autoCheckCamboCarGuy({ commit, dispatch }, form) {
    await axios
      .post('/api/autochecks/cambo-autochecks', form)
      .then((resp) => {
        if (resp.status === 201) {
          commit('ADD_AUTOCHECK', resp.data)
          let notification = {
            id: Date.now(),
            message: 'VIN check report is successfully generated',
            title: 'Autocheck',
            type: 'success',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        }
      })
      .catch((err) => {
        let notification = {
          id: Date.now(),
          message: `${err.response.VIN} ${err.response.status}`,
          title: err.response.type.toUpperCase(),
          type: 'error',
        }
        dispatch('notification/addNotification', notification, {
          root: true,
        })
      })
  },
}
